const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/pages/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { pagesSearchSchema } from "@circle-react/components/SettingsApp/Site/Pages/searchParams";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/pages/")({
  validateSearch: pagesSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});